import * as React from 'react'
import styled from 'styled-components'

export const PopupFormWrapper = styled.div`
    padding: 50px;
    text-align: left;
    background-color: rgb(245, 246, 250);
`
